<template>
  <div>
    <h5 class="text-muted">Estado Documento</h5>
    <span>{{ statusDocument }}</span>
    <div v-for="(reg, idx) in events" :key="idx">
      <CCallout :color="getColor(reg.evento)">
        <div>
          <h5 class="text-muted">Evento: <strong>{{ reg.evento }}</strong></h5>
        </div>
        <div>
          <span>{{ reg.descripcion }}</span>
        </div>
        <div>
          <i class="bi bi-calendar-check text-info mr-1"></i>
          <span>{{ moment(reg.fechaHora_Evento).format("DD/MM/YYYY - hh:mm:ss a") }}</span>
        </div>
      </CCallout>
    </div>

    <CElementCover v-show="loading">
      <CSpinner grow color="info" size="sm" />
    </CElementCover>
  </div>
</template>

<script>
  import moment from "moment";
  import { dataEventosDocumentoElectronico } from "@/apiData";

  export default ({
    name: "EventsDocumentPanel",
    data() {
      return {
        loading: false,
        statusDocument: "",
        events: []
      }
    },
    props: {
      uuid: String,
      idDocument: String,
      typeDocument: String
    },
    methods: {
      moment,
      async getEventsDocument() {
        this.loading = true

        try {
          // const { errorCode, errorMessage, response } = await dataEventosDocumentoElectronico(this, this.idDocument, "C");
          const { errorCode, errorMessage, response } = await dataEventosDocumentoElectronico(this, this.uuid);

          console.log(errorCode);
          console.log(errorMessage);
          console.log(response);
  
          this.statusDocument = response.estado_Documento;
          this.events = response.eventos;
        } catch(error) {
          this.$store.commit("setAlert", {
            color: "danger",
            message: `${error}`,
            show: 5
          })
        } finally {
          this.loading = false
        }
      },
      getColor(eventCode) {
        if (eventCode === "030") return "info";
        if (eventCode === "031") return "danger";
        if (eventCode === "032") return "warning";
        if (eventCode === "033") return "success";
        if (eventCode === "034") return "success";
      }
    },
    mounted() {
      this.getEventsDocument();
    }
  });
</script>
